import React from "react";
import Card from "../../ui/Card";
import Skeleton from "../../ui/Skeleton";

const IntelligentInsightsSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 animate-pulse">
      {/* Model Status Header — mesma geometria da barra de título de página
          real (rounded-2xl, sem box de ícone, sem borda inferior). */}
      <div className="flex items-center justify-between gap-3 flex-wrap min-h-[52px] bg-white/70 border border-purple-200 rounded-2xl px-4 sm:px-5 py-2.5 shadow-xs">
        <div className="flex items-center gap-2">
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
          <div>
            <Skeleton
              variant="text"
              width={180}
              height={16}
              className="mb-1.5"
            />
            <Skeleton variant="text" width={220} height={12} />
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton
            variant="rectangular"
            width={160}
            height={36}
            className="rounded-lg"
          />
          <Skeleton
            variant="rectangular"
            width={140}
            height={36}
            className="rounded-lg"
          />
        </div>
      </div>

      {/* Content Suggestions Grid */}
      <div className="space-y-2">
        <div className="flex items-center gap-3 px-2">
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
          <Skeleton variant="text" width={200} height={16} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {[1, 2].map((i) => (
            <Card key={i} className="p-3 border-purple-200">
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-3">
                  <Skeleton
                    variant="rectangular"
                    width={32}
                    height={32}
                    className="rounded-xl"
                  />
                  <Skeleton variant="text" width={120} height={16} />
                </div>
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={22}
                  className="rounded-full"
                />
              </div>
              <Skeleton
                variant="text"
                width="90%"
                height={14}
                className="mb-1"
              />
              <Skeleton
                variant="text"
                width="70%"
                height={14}
                className="mb-2"
              />
              <div className="space-y-1">
                <Skeleton variant="text" width="40%" height={10} />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={6}
                  className="rounded-full"
                />
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* Stats Grid */}
      <div className="space-y-2">
        <div className="flex items-center gap-3 px-2">
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
          <Skeleton variant="text" width={140} height={16} />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="relative overflow-hidden bg-white rounded-xl border border-purple-200 p-4"
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={3}
                className="absolute top-0 left-0 rounded-none"
              />
              <div className="flex items-start justify-between pt-0.5">
                <div className="space-y-1.5">
                  <Skeleton variant="text" width={60} height={10} />
                  <Skeleton variant="text" width={50} height={24} />
                </div>
                <Skeleton
                  variant="rectangular"
                  width={36}
                  height={36}
                  className="rounded-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Advanced Optimization Card */}
      <Card className="p-3 border-purple-200">
        <div className="flex items-center gap-3 mb-3">
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            className="rounded-xl"
          />
          <Skeleton variant="text" width={180} height={16} />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
          <div className="space-y-2">
            <Skeleton variant="text" width={140} height={12} />
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="flex justify-between items-center py-2 border-b border-purple-200"
              >
                <Skeleton variant="text" width={120} height={12} />
                <Skeleton variant="text" width={60} height={12} />
              </div>
            ))}
          </div>
          <div className="space-y-2">
            <Skeleton variant="text" width={140} height={12} />
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="100%"
                height={40}
                className="rounded-lg"
              />
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default IntelligentInsightsSkeleton;
